import { useEffect, useRef, useState } from "react";
import { Link, useNavigate, useParams } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { FormControl, Tab, Grid, Table, CommonErrors } from "@/comn/components";
import { comnEnvs, comnUtils } from "@/comn/utils";
import { Page, Group, Layout, Button, ExcelUpload } from "@/comn/components";
import { lpcoEnvs, lpcoUtils } from "@/tz/go/egaz/osci/lpco/comn";
import {
    useForm,
    useFetch,
    useGrid,
    useResource,
    usePopup,
    useStore,
    useToast,
    useAuth,
    useModal,
    useTab,
    usePage,
} from "@/comn/hooks";
import {
    BASE,
    URLS,
    APIS,
    SF_SCHEMA_HS_APP,
    SG_APP_HS_CODE_LIST,
    SG_HS_APRV_HIST_LIST,
} from "@/tz/go/egaz/osci/lpco/hscd/itm/service/OsciHscdItmService";

export const OSCI0204004S = (props: any) => {
    /*
     * Declaration Hook, Meta
     * !== Hook, 메타 정보 정의 ==!
     */
    const { pgeUid, menuId } = usePage({
        auth: ["auth_osci0004"],
    });
    const pgeTitle = "Registering Control HS Code"; // Page Title !== 페이지 타이틀 ==!
    const { t } = useTranslation(); // Translation Hook !== 언어 변화 Hook ==!
    const navigate = useNavigate(); // Navigate Hook !== 화면 이동 Hook ==!
    const modal = useModal(); // Modal Window Hook !== Modal 창 Hook ==!
    const { pgeStore, setStore } = useStore({ pgeUid: pgeUid }); // Page Store Hook !== 화면 데이터 저장 Hook ==!
    const toast = useToast(); // Toast Message Hook !== Toast 메세지 표시 Hook ==!
    const auth = useAuth(); // Login , User Information Hook !== 로그인, 유저정보 Hook ==!

    const { hsAppId } = useParams();

    const [hsAppDtlList, setHsAppDtlList] = useState(comnUtils.getGridData([]));

    const [hsAppAprvHistList, setHsAppAprvHistList] = useState(comnUtils.getGridData([]));
    const [hsAppOriginDtlList, setHsAppOriginDtlList] = useState(comnUtils.getGridData([]));
    const [oringinCount, setOriginCount] = useState(0);

    const [prcssStatCd, setPrcssStatCd] = useState("");

    const refEditable = useRef(false);
    const refSubmittable = useRef(false);

    const tab = useTab({
        defaultSchema: {
            id: "tab",
            schema: [{ label: t("L_HS_CD") }, { label: t("T_APRV_HIST") }],
        },
    });

    /*
     * Code Resource
     * !== 사용할 Code 정의 ==!
     */
    useResource({
        defaultSchema: [
            { area: "hsCd" },
            { area: "comnCd", comnCd: "OSC0133" },
            { area: "comnCd", comnCd: "OSC0134" },
            { area: "comnCd", comnCd: "OSC0132" },
            { area: "comnCd", comnCd: "OSC0131" },
            { area: "comnCd", comnCd: "OSC0119" },
        ],
    });

    type HsCodeData = {
        hsCd: string;
        godsDesc?: string;
        inscTrgtYn: string;
        appdStrtDt: string;
        appdEndDt: string;
    };

    /*
     * Declaration Form
     * !== 폼 정의 ==!
     */
    const form = {
        // Registering HS Code Form !== HS 신청 Form==!
        hsAppForm: useForm({
            defaultSchema: SF_SCHEMA_HS_APP,
            defaultValues: {
                appDt: new Date(),
                prcssStatCd: "DR",
                orgChpnNm: auth.get("usrNm"),
                orgChpnId: auth.get("usrId"),
                orgChpnTelno: auth.get("telNo"),
                orgChpnEml: auth.get("emlAddr"),
                orgCd: auth.get("orgCd"),
                orgNm: auth.get("orgNm"),
            },
        }),
    };

    /*
     * Declaration Grid
     * !== 그리드 정의 ==!
     */
    const grid = {
        // Registering HS Code List !== Item Tab HS Code 등록 ==!
        appHsCodeList: useGrid({
            defaultSchema: SG_APP_HS_CODE_LIST,
            page: 0,
            size: 10,
        }),
        hsAppAprvHistList: useGrid({
            defaultSchema: SG_HS_APRV_HIST_LIST,
            page: 0,
            size: 10,
        }),
    };
    const render = {
        hsAppDtlList: {
            head: {},
            cell: {},
            edit: {
                // hsCd: (props: any) => {
                //     const { binding, rowValues, value } = props;
                //     return (
                //         <FormControl
                //             type="code"
                //             area="hsCd"
                //             disabled={rowValues.deletableYn == "N"}
                //             value={rowValues.hsCd}
                //             onChange={async (v: any) => {
                //                 grid.appHsCodeList.updateRow({
                //                     ...rowValues,
                //                     hsCd: v,
                //                 });
                //             }}
                //         />
                //     );
                // },
                inscTrgtYn: (props: any) => {
                    const { binding, rowValues, value } = props;
                    const inscTrgtYn = rowValues.inscTrgtYn;
                    let imexTpCd = rowValues.imexTpCd;
                    return (
                        <FormControl
                            type="select"
                            comnCd="OSC0134"
                            area="comnCd"
                            value={rowValues.inscTrgtYn}
                            onChange={async (v: any) => {
                                if (v == "N") {
                                    imexTpCd = "";
                                }
                                grid.appHsCodeList.updateRow({
                                    ...rowValues,
                                    inscTrgtYn: v,
                                    imexTpCd: imexTpCd,
                                });
                            }}
                        />
                    );
                },
                imexTpCd: (props: any) => {
                    const { binding, rowValues, value } = props;

                    const inscTrgtYn = rowValues.inscTrgtYn;
                    return (
                        <FormControl
                            type="select"
                            comnCd="OSC0133"
                            area="comnCd"
                            value={rowValues.imexTpCd}
                            disabled={inscTrgtYn == "N"}
                            required={inscTrgtYn == "Y"}
                            onChange={async (v: any) => {
                                grid.appHsCodeList.updateRow({
                                    ...rowValues,
                                    imexTpCd: v,
                                });
                            }}
                        />
                    );
                },
            },
            row: (row: any, context: any) => {
                // row : 해당 row 의 데이터(rowValues)
                // return 값이 true 이면 row 보임
                // return 값이 false 이면 row 숨김
                // context 의 속성을 변경하여 row 의 바탕색 변경 가능
                if (row.prcsRoleTpCd === "SU" || row.prcsRoleTpCd === "AP") {
                    //context.backgroundColor = "blue"; // 3가지 색상 옵션 red , yellow , blue
                }
                return true;
            },
            checkbox: (row: any) => {
                // row : 해당 row 의 데이터(rowValues)
                return true; //!(row.deletableYn === "N");
            },
        },
        hsAppAprvHistList: {},
    };

    /*
     * Declaration Fetch
     * !== Fetch 정의 ==!
     */
    const fetch = {
        updateHsAppInfo: useFetch({
            api: (hsAppId, data) => APIS.updateHsAppInfo(hsAppId, { ...data }),
            onSuccess: (data) => {
                modal.openModal({
                    content: "msg.osc.00006" /**Processed successfully. */,
                    onConfirm: () => {
                        if (data.saveInfo?.content?.mode == "SU") {
                            navigate(URLS.osci0204002q);
                        } else {
                            navigate(URLS.osci0204003s + "/" + hsAppId);
                        }
                    },
                    onCancel: () => {
                        //navigate(URLS.osci0204002q + "/" + data.saveInfo?.content?.hsAppId);
                    },
                });
            },
            onError: (err) => {
                modal.openModal({ content: err.response.data.errorMessage });
            },
        }),
        getOgaHsCdList: useFetch({
            api: (orgCd) => {
                return APIS.getOgaHsCdList(orgCd);
            },
            onSuccess: (data) => {
                console.log("getOgaHsCdList onSuccess ", data.list?.content);
                // form.lpcoInfoRgsr.setValues(data.appInfo.content?.info);
                setHsAppDtlList(comnUtils.getGridData(data.list?.content || []));
            },
            onError: () => {},
            showToast: false,
        }),
        getHsAppInfo: useFetch({
            api: (hsAppId) => {
                return APIS.getHsAppInfo(hsAppId);
            },
            onSuccess: (data) => {
                console.log("getAppDtl onSuccess ==================== ", data);
                if (!data.appInfo.content.info || !data.appInfo.content.info?.hsAppId) {
                    // no data
                    modal.openModal({
                        content: "msg.osc.00050",
                        onCancel: () => {
                            navigate(URLS.osci0204002q);
                        },
                    });
                } else {
                    form.hsAppForm.setValues(data.appInfo.content.info);

                    const orgChpnId = form.hsAppForm.getValue("orgChpnId");
                    const prcssStatCd = form.hsAppForm.getValue("prcssStatCd");
                    refEditable.current =
                        (orgChpnId == auth.get("usrId") || orgChpnId == auth.get("asisSysmUsrId")) &&
                        (prcssStatCd == "DR" || prcssStatCd == "RE");

                    setPrcssStatCd(prcssStatCd);
                    setHsAppDtlList(comnUtils.getGridData(data.appInfo?.content?.list || []));
                }
            },
            onError: () => {
                toast.showToast({ type: "error", content: "msg.osc.00043" });
            },
            showToast: false,
        }),
        deleteHsAppInfo: useFetch({
            api: (hsAppId) => {
                return APIS.deleteHsAppInfo(hsAppId);
            },
            onSuccess: (data) => {
                // no data
                modal.openModal({
                    content: "msg.osc.00071",
                    onCancel: () => {
                        navigate(URLS.osci0204002q);
                    },
                });
            },
            onError: (err) => {
                modal.openModal({ content: err.response.data.errorMessage });
            },
            showToast: false,
        }),
        getHsAppAprvHistList: useFetch({
            api: (hsAppId) => {
                return APIS.getHsAppAprvHistList(hsAppId);
            },
            onSuccess: (data) => {
                console.log("getAppDtl onSuccess ==================== ", data);
                setHsAppAprvHistList(comnUtils.getGridData(data.result?.content || []));
            },
            onError: () => {
                toast.showToast({ type: "error", content: "msg.osc.00043" });
            },
            showToast: false,
        }),
    };

    /*
     * Declaration Event Handler
     * !== 이벤트 핸들러 정의 ==!
     */
    const handler = {
        // Delete Item list deletion event !== 품목 목록 삭제 이벤트 ==!
        click_Btn_DeleteGridAppHsCodeList: () => {
            const seltList: any[] = grid.appHsCodeList.getChecked() || [];
            if (comnUtils.isEmpty(seltList)) {
                modal.openModal({ content: "msg.osc.00009" });
                return;
            }

            grid.appHsCodeList.deleteRow("checkbox");

            // modal.openModal({
            //     content: "msg.osc.00095",
            //     onConfirm: () => {
            //         grid.appHsCodeList.deleteRow("checkbox");
            //     },
            // });
        },
        deleteHsAppInfo: (hsAppId: any) => {
            modal.openModal({
                content: "msg.osc.00095",
                onConfirm: () => {
                    fetch.deleteHsAppInfo.fetch(hsAppId);
                },
            });
        },

        validUploadData: (data: HsCodeData[]) => {
            let errResult = {} as { errors: any[] };
            errResult["errors"] = [];
            const duplMap: { [key: string]: boolean } = {};

            data.forEach((row, index) => {
                const rowNumber = index + 2;
                // 1. Check hsCd : If there is a Row that is not 12 digits even if it is 1 case, do not apply Excel upload
                // !== hsCd 확인: HS Code는 12자리여야 함.==!
                if (!/^\d{12}$/.test(row.hsCd)) {
                    let msg = `${t("msg.osc.00134")}`;
                    errResult.errors.push(lpcoUtils.getErrorObj(rowNumber, "L_HS_CD", msg, row.hsCd)); // HS Code must be 12 digits. !== HS Code 는 12자리여야 합니다. ==!
                }

                // 2. Date check: appdStrtDt, appdEndDt "YYYY-MM-DD" format required
                // !== 2. 날짜 확인 : 시작일자, 종료일자 는 "YYYY-MM-DD" 형식이어야 함. ==!
                const dateFormat = /^\d{4}-\d{2}-\d{2}$/;
                if (!dateFormat.test(row.appdStrtDt)) {
                    let tempLabel = t("L_VLD_STRT_DT");
                    let msg = `${t("msg.osc.00135", { 0: tempLabel })}`; // {0} must follow the “YYYY-MM-DD” format. !== {0}은 "YYYY-MM-DD" 형식 이어야 합니다. ==!
                    console.log(row.appdStrtDt);
                    errResult.errors.push(lpcoUtils.getErrorObj(rowNumber, "L_VLD_STRT_DT", msg, row.appdStrtDt));
                }
                if (!dateFormat.test(row.appdEndDt)) {
                    let tempLabel = t("L_VLD_END_DT");
                    let msg = `${t("msg.osc.00135", { 0: tempLabel })}`; // {0} must follow the “YYYY-MM-DD” format. !== {0}은 "YYYY-MM-DD" 형식 이어야 합니다. ==!
                    errResult.errors.push(lpcoUtils.getErrorObj(rowNumber, "L_VLD_END_DT", msg, row.appdEndDt));
                }
                // 3. Date check: appdStrtDt appdEndDt cannot be small
                // !== 3. 날짜 확인 : 시작일자는 종료일자 이후일 수 없음 ==!
                if (new Date(row.appdStrtDt) > new Date(row.appdEndDt)) {
                    let msg = `${t("msg.osc.00049")}`; // Start date cannot be later than end date. !== 시작일자는 종료일자보다 이후일 수 없습니다. ==!
                    errResult.errors.push(lpcoUtils.getErrorObj(rowNumber, "L_VLD_STRT_DT", msg, row.appdStrtDt));
                }

                // 4. Required values check : hsCd, inscTrgtYn, appdStrtDt, appdEndDt
                // !== 필수값 확인 : hsCd, inscTrgtYn, appdStrtDt, appdEndDt ==!
                if (!row.hsCd) {
                    let tempLabel = t("L_HS_CD");
                    let msg = `${t("msg.osc.00068", { 0: tempLabel })}`; // {0} information is required information. !== {0} 정보는 필수 입력 정보입니다. ==!
                    errResult.errors.push(lpcoUtils.getErrorObj(rowNumber, "L_HS_CD", msg, ""));
                }
                if (!row.inscTrgtYn) {
                    let tempLabel = t("L_INSC_TRGT_YN");
                    let msg = `${t("msg.osc.00068", { 0: tempLabel })}`; // {0} information is required information. !== {0} 정보는 필수 입력 정보입니다. ==!
                    errResult.errors.push(lpcoUtils.getErrorObj(rowNumber, "L_INSC_TRGT_YN", msg, ""));
                }
                if (!row.appdStrtDt) {
                    let tempLabel = t("L_VLD_STRT_DT");
                    let msg = `${t("msg.osc.00068", { 0: tempLabel })}`; // {0} information is required information. !== {0} 정보는 필수 입력 정보입니다. ==!
                    errResult.errors.push(lpcoUtils.getErrorObj(rowNumber, "L_VLD_STRT_DT", msg, ""));
                }
                if (!row.appdEndDt) {
                    let tempLabel = t("L_VLD_END_DT");
                    let msg = `${t("msg.osc.00068", { 0: tempLabel })}`; // {0} information is required information. !== {0} 정보는 필수 입력 정보입니다. ==!
                    errResult.errors.push(lpcoUtils.getErrorObj(rowNumber, "L_VLD_END_DT", msg, ""));
                }
                // 5. Check duplicate HS Code
                // !== 중복 HS Code 확인 ==!
                if (row.hsCd) {
                    if (duplMap[row.hsCd]) {
                        let label = t("L_HS_CD");
                        let msg = t("msg.osc.00150", { 0: label }); // Duplicate data exists. ( {0} )!== 중복된 데이터가 존재합니다. ( {0} ) ==!
                        errResult.errors.push(lpcoUtils.getErrorObj(rowNumber, "L_HS_CD", msg, row.hsCd));
                    } else {
                        duplMap[row.hsCd] = true;
                    }
                }
            });
            return {
                isValid: errResult.errors.length === 0,
                errResult,
            };
        },

        // Save Component !== Additional Info 저장 ==!
        updateHsAppInfo: form.hsAppForm.handleSubmit(async () => {
            const hsAppDtlList = grid.appHsCodeList.getData();

            let bCheck = true;
            if (hsAppDtlList.filter((item) => item.__type !== "deleted").length < 1) {
                // Please enter Hs Code. !== HS CODE를 입력하세요. ==!
                bCheck = false;
                modal.openModal({
                    content: "msg.osc.00055",
                });
            } else {
                const hsCdList = grid.appHsCodeList.getViewData();
                const validationResult = handler.validUploadData(hsCdList);

                console.log("[hsCdList]: =============================>");
                if (!validationResult.isValid) {
                    // sort by row
                    validationResult.errResult.errors = lpcoUtils.errorListSortByRow(validationResult.errResult.errors);
                    // error layer popup
                    modal.openModal({
                        content: <CommonErrors {...validationResult.errResult} />,
                        size: "lg",
                        draggable: true,
                    });
                    console.log(hsCdList);
                    console.log("///1");
                } else {
                    console.log("[data]: =============================>");
                    const saveReqList = [...grid.appHsCodeList.getDeletedData(), ...hsCdList];
                    const data = { ...form.hsAppForm.getValues(), hsAppDtlList: saveReqList };
                    console.log(data);
                    const mode = data.mode;
                    let msgId = "msg.osc.00090";
                    if (mode == "SU") msgId = "msg.osc.00092";
                    console.log("///2");
                    modal.openModal({
                        content: msgId,
                        onConfirm: () => {
                            fetch.updateHsAppInfo.fetch(hsAppId, data);
                            console.log("///3");
                        },
                    });
                }
            }
        }),

        setInit: async () => {
            // HS App Information
            await fetch.getHsAppInfo.fetch(hsAppId);

            await fetch.getHsAppAprvHistList.fetch(hsAppId);
        },
    };

    // useEffect
    useEffect(() => {
        handler.setInit();
    }, []);
    useEffect(() => {
        console.log(setHsAppOriginDtlList);
    }, [hsAppOriginDtlList]);

    return (
        <Page>
            {/* <form> */}
            <Group>
                <Group.Body>
                    <Layout>
                        <Layout.Left>
                            <Group.Title title={t("L_APP_INFO")} titleSize={1}></Group.Title>
                        </Layout.Left>
                    </Layout>
                    <Group.Section>
                        <Group.Row>
                            <Group.Control {...form.hsAppForm.schema.orgNm} />
                        </Group.Row>

                        <Group.Row>
                            <Group.Control {...form.hsAppForm.schema.orgChpnNm} />
                        </Group.Row>
                        <Group.Row>
                            <Group.Control {...form.hsAppForm.schema.orgChpnTelno} />
                            <Group.Control {...form.hsAppForm.schema.orgChpnEml} />
                        </Group.Row>
                        <Group.Row>
                            <Group.Control {...form.hsAppForm.schema.hsAppNo} />
                            <Group.Control {...form.hsAppForm.schema.prcssStatCd} />
                        </Group.Row>
                    </Group.Section>

                    <Layout direction="row">
                        <Layout.Left>
                            <Button
                                role="list"
                                onClick={() => {
                                    navigate(URLS.osci0204002q);
                                }}
                            />
                        </Layout.Left>
                        <Layout.Right>
                            {refEditable.current && (
                                <>
                                    <Button
                                        role="save"
                                        onClick={() => {
                                            form.hsAppForm.setValue("mode", "DR");
                                            handler.updateHsAppInfo();
                                        }}
                                    />
                                    {/* <Button variant="warning" onClick={() => {}}>
                                        {t("Verify")}
                                    </Button> */}
                                    <Button
                                        role="submit"
                                        onClick={() => {
                                            form.hsAppForm.setValue("mode", "SU");
                                            handler.updateHsAppInfo();
                                        }}
                                    />
                                </>
                            )}
                            <Button
                                role="cancel"
                                onClick={() => {
                                    navigate(URLS.osci0204003s + "/" + hsAppId);
                                }}
                            />
                        </Layout.Right>
                    </Layout>
                </Group.Body>
            </Group>
            <Group>
                <Group.Body>
                    <Tab {...tab.tab}>
                        <Tab.Panel>
                            <Group>
                                <Group.Body>
                                    <Layout>
                                        <Layout.Left>
                                            <Group.Title title={t("T_HS_CD_LST")} titleSize={1}></Group.Title>
                                        </Layout.Left>
                                    </Layout>
                                    <Layout>
                                        <Layout.Left>
                                            <Button
                                                role="tmplDown"
                                                onClick={() => {
                                                    lpcoUtils.saveExcelDownload(
                                                        process.env.REACT_APP_API_OSCI +
                                                            "/api/v1/osci/lpco/hscd/itm/excel-template",
                                                        {},
                                                    );
                                                }}
                                            >
                                                Template Download
                                            </Button>
                                            <Button
                                                role="excelUpload"
                                                onClick={async () => {
                                                    modal.openModal({
                                                        content: t("msg.osc.00136"), // When entering HS Code through Excel upload, previously entered values will be deleted. !== 엑셀업로드를 통해 HS Code를 입력 시 사전에 입력한 값은 지워집니다. ==!
                                                        onConfirm: async () => {
                                                            const data =
                                                                (await grid.appHsCodeList.importExcel({
                                                                    headers: 1,
                                                                    bindings: {
                                                                        A: "hsCd",
                                                                        B: "godsDesc",
                                                                        C: "inscTrgtYn",
                                                                        D: "imexTpCd",
                                                                        E: "appdStrtDt",
                                                                        F: "appdEndDt",
                                                                    },
                                                                    sheet: 0,
                                                                })) || [];
                                                            //시트명, 헤더 ROW 수
                                                            const validationResult = handler.validUploadData(data);
                                                            if (!validationResult.isValid) {
                                                                validationResult.errResult.errors =
                                                                    lpcoUtils.errorListSortByRow(
                                                                        validationResult.errResult.errors,
                                                                    );
                                                                modal.openModal({
                                                                    content: (
                                                                        <CommonErrors {...validationResult.errResult} />
                                                                    ),
                                                                    size: "lg",
                                                                    draggable: true,
                                                                });
                                                                return;
                                                            }
                                                            // updateRow
                                                            if (oringinCount === 0) {
                                                                let originData = await grid.appHsCodeList.getData();
                                                                originData.forEach((item) => {
                                                                    item.__index = 1;
                                                                    item.__type = "deleted";
                                                                });
                                                                let temp = comnUtils.getGridData([...originData]);
                                                                setHsAppOriginDtlList(temp);
                                                                setOriginCount(oringinCount + 1);
                                                            }
                                                            await grid.appHsCodeList.setData(
                                                                comnUtils.getGridData([...data]),
                                                            );
                                                        },
                                                    });
                                                }}
                                            ></Button>
                                        </Layout.Left>
                                        <Layout.Right>
                                            {refEditable.current && (
                                                <>
                                                    <Button
                                                        role="gridAdd"
                                                        onClick={() => {
                                                            //alert("test");
                                                            grid.appHsCodeList.addRow({
                                                                appdStrtDt: comnUtils.dateToString(new Date(), "date"),
                                                                inscTrgtYn: "N",
                                                            });
                                                        }}
                                                    ></Button>
                                                    <Button
                                                        role="gridDelete"
                                                        onClick={() => {
                                                            handler.click_Btn_DeleteGridAppHsCodeList();
                                                        }}
                                                    ></Button>
                                                </>
                                            )}
                                        </Layout.Right>
                                    </Layout>
                                    <Group.Section>
                                        <Grid
                                            {...grid.appHsCodeList.grid}
                                            data={hsAppDtlList}
                                            render={render.hsAppDtlList}
                                        />
                                    </Group.Section>
                                </Group.Body>
                            </Group>
                        </Tab.Panel>
                        <Tab.Panel>
                            <Group>
                                <Group.Body>
                                    <Layout>
                                        <Layout.Left>
                                            <Group.Title title={t("T_APRV_HIST")} titleSize={1}></Group.Title>
                                        </Layout.Left>
                                        <Layout.Right></Layout.Right>
                                    </Layout>

                                    <Group.Section>
                                        <Grid
                                            {...grid.hsAppAprvHistList.grid}
                                            data={hsAppAprvHistList}
                                            render={render.hsAppAprvHistList}
                                        />
                                    </Group.Section>
                                </Group.Body>
                            </Group>
                        </Tab.Panel>
                    </Tab>
                </Group.Body>
            </Group>
        </Page>
    );
};
